<div *ngIf="capture.verified && canManageVerfieidInvalidReviewed" class="py-1 ps-2" [ngClass]="{ 'bg-light': !enabled, 'bg-success': enabled }">
  <div class="form-check">
    <input type="checkbox" class="form-check-input" (click)="onClick()" [(ngModel)]="enabled">
    <label class="form-check-label" for="exampleCheck1">VERIFIED INVALID REVIEWED</label>
  </div>
</div>
